(ns nl.mediquest.questionnaire-frontend.component.report.regeldruk.calculations
  "See https://docs.google.com/spreadsheets/d/1fnMvt1qWir8P4r19V0VHHkS_K0OonJoYY2GXqAAt41o")

(defn- theme-a-medisch-specialist-value [{:keys [question_a9
                                                 question_a10
                                                 question_a11
                                                 question_a12
                                                 question_a13
                                                 question_a14
                                                 question_a15
                                                 question_a16] :as _data}]
  (+ question_a9
     question_a10
     question_a11
     question_a12
     question_a13
     question_a14
     question_a15
     question_a16))

(defn- theme-b-medisch-specialist-value [{:keys [question_b1
                                                 question_b2
                                                 question_b3
                                                 question_b5
                                                 question_b7] :as _data}]
  (+ question_b1
     question_b2
     question_b3
     question_b5
     question_b7))

(defn- theme-c-medisch-specialist-value [{:keys [question_c1
                                                 question_c2
                                                 question_c3
                                                 question_c4
                                                 question_c5
                                                 question_c6
                                                 question_c7
                                                 question_c8
                                                 question_c9
                                                 question_c10] :as _data}]
  (+ question_c1
     question_c2
     question_c3
     question_c4
     question_c5
     question_c6
     question_c7
     question_c8
     question_c9
     question_c10))

(defn- theme-d-medisch-specialist-value [{:keys [question_d1] :as _data}]
  question_d1)

(defn- theme-e-medisch-specialist-value [{:keys [question_e1] :as _data}]
  question_e1)

(defn- theme-f-medisch-specialist-value [{:keys [question_f1] :as _data}]
  question_f1)

(defn- theme-g-medisch-specialist-value [{:keys [question_g1] :as _data}]
  question_g1)

(defn- theme-a-kwaliteitsmedewerker-value [{:keys [question_a8k
                                                   question_a9k
                                                   question_a10k
                                                   question_a11k
                                                   question_a12k
                                                   question_a13k
                                                   question_a14k
                                                   question_a15k] :as _data}]
  (+ question_a8k
     question_a9k
     question_a10k
     question_a11k
     question_a12k
     question_a13k
     question_a14k
     question_a15k))

(defn- theme-b-kwaliteitsmedewerker-value [{:keys [question_b1k
                                                   question_b2k
                                                   question_b3k
                                                   question_b5k
                                                   question_b6k
                                                   question_b7k
                                                   question_b9k
                                                   question_b10k
                                                   question_b11k
                                                   question_b12k] :as _data}]
  (+ question_b1k
     question_b2k
     question_b3k
     question_b5k
     question_b6k
     question_b7k
     question_b9k
     question_b10k
     question_b11k
     question_b12k))

(defn- theme-c-kwaliteitsmedewerker-value [{:keys [question_c1k
                                                   question_c2k
                                                   question_c3k
                                                   question_c4k
                                                   question_c5k
                                                   question_c6k
                                                   question_c7k
                                                   question_c8k
                                                   question_c9k] :as _data}]
  (+ question_c1k
     question_c2k
     question_c3k
     question_c4k
     question_c5k
     question_c6k
     question_c7k
     question_c8k
     question_c9k))

(defn- theme-d-kwaliteitsmedewerker-value [{:keys [question_d1k] :as _data}]
  question_d1k)

(defn- theme-f-kwaliteitsmedewerker-value [{:keys [question_f1k] :as _data}]
  question_f1k)

(defn- theme-g-kwaliteitsmedewerker-value [{:keys [question_g1k] :as _data}]
  question_g1k)

(defn- theme-b-verpleegkundige-value [{:keys [question_b1v
                                              question_b2v
                                              question_b3v
                                              question_b5v
                                              question_b6v] :as _data}]
  (+ question_b1v
     question_b2v
     question_b3v
     question_b5v
     question_b6v))

(defn- theme-c-verpleegkundige-value [{:keys [question_c1v
                                              question_c2v
                                              question_c3v
                                              question_c4v
                                              question_c5v
                                              question_c6v
                                              question_c7v] :as _data}]
  (+ question_c1v
     question_c2v
     question_c3v
     question_c4v
     question_c5v
     question_c6v
     question_c7v))

(defn- theme-d-verpleegkundige-value [{:keys [question_d1v] :as _data}]
  question_d1v)

(defn- theme-g-verpleegkundige-value [{:keys [question_g1v] :as _data}]
  question_g1v)

(defn- calculations [data]
  {:medisch-specialist
   {:a {:max-value 40 :value (theme-a-medisch-specialist-value data)}
    :b {:max-value 25 :value (theme-b-medisch-specialist-value data)}
    :c {:max-value 50 :value (theme-c-medisch-specialist-value data)}
    :d {:max-value 5 :value (theme-d-medisch-specialist-value data)}
    :e {:max-value 5 :value (theme-e-medisch-specialist-value data)}
    :f {:max-value 5 :value (theme-f-medisch-specialist-value data)}
    :g {:max-value 5 :value (theme-g-medisch-specialist-value data)}}
   :kwaliteitsmedewerker
   {:a {:max-value 40 :value (theme-a-kwaliteitsmedewerker-value data)}
    :b {:max-value 50 :value (theme-b-kwaliteitsmedewerker-value data)}
    :c {:max-value 45 :value (theme-c-kwaliteitsmedewerker-value data)}
    :d {:max-value 5 :value (theme-d-kwaliteitsmedewerker-value data)}
    :f {:max-value 5 :value (theme-f-kwaliteitsmedewerker-value data)}
    :g {:max-value 5 :value (theme-g-kwaliteitsmedewerker-value data)}}
   :verpleegkundige
   {:b {:max-value 25 :value (theme-b-verpleegkundige-value data)}
    :c {:max-value 35 :value (theme-c-verpleegkundige-value data)}
    :d {:max-value 5 :value (theme-d-verpleegkundige-value data)}
    :g {:max-value 5 :value (theme-g-verpleegkundige-value data)}}})

(def re-int-string-with-possible-spaces
  #"^\s*\d+\s*$")

(defn- parse-int [v]
  (if (and (string? v) (re-matches re-int-string-with-possible-spaces v))
    (js/parseInt v)
    v))

(defn- parse-ints
  "Radiogroup returns strings instead of integers as values, here we convert all
  integer strings to an integer"
  [data]
  (into {} (for [[k v] data] [k (parse-int v)])))

(defn add-calculations [data]
  (assoc data :calculations (calculations (parse-ints data))))
